export interface IPrimeNgFilterRequest {
  filters?: string;
  first?: number;
  rows?: number;
  sortField?: string | undefined;
  sortOrder?: number;
  filterHandle?: string | undefined;
  tagHandle?: string | undefined;
  globalFilter?: string | undefined;
  status?: number | undefined;
  direction?: number | undefined;
}

export class PrimeNgFilterRequest implements IPrimeNgFilterRequest {
  filters?: string;
  first?: number;
  rows?: number;
  sortField?: string | undefined;
  sortOrder?: number;
  filterHandle?: string | undefined;
  tagHandle?: string | undefined;
  globalFilter?: string | undefined;
  status?: number;
  direction?: number;

  constructor(data?: IPrimeNgFilterRequest) {
    if (data) {
      for (const property in data) {
        if (Object.prototype.hasOwnProperty.call(data, property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.filters = _data['filters'];
      this.first = _data['first'];
      this.rows = _data['rows'];
      this.sortField = _data['sortField'];
      this.sortOrder = _data['sortOrder'];
      this.filterHandle = _data['filterHandle'];
      this.tagHandle = _data['tagHandle'];
      this.globalFilter = _data['globalFilter'];
    }
  }

  static fromJS(data: any): PrimeNgFilterRequest {
    data = typeof data === 'object' ? data : {};
    const result = new PrimeNgFilterRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['filters'] = this.filters;
    data['first'] = this.first;
    data['rows'] = this.rows;
    data['sortField'] = this.sortField;
    data['sortOrder'] = this.sortOrder;
    data['filterHandle'] = this.filterHandle;
    data['tagHandle'] = this.tagHandle;
    data['globalFilter'] = this.globalFilter;
    return data;
  }
}
